import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { getUserTimeZone } from 'infrastructure/functions';

dayjs.extend(utc);
dayjs.extend(timezone);

export const getTodayRangeTimestamps = () => {
  const userTz = getUserTimeZone();
  const now = dayjs().tz(userTz);
  const startOfDay = now.startOf('day');
  const endOfDay = now.endOf('day');

  return {
    from: startOfDay.utc().valueOf(),
    to: endOfDay.utc().valueOf(),
    now: now.utc().valueOf(),
  };
};

export const getLast7DaysRangeTimestamps = () => {
  const now = dayjs();
  const startTime = now.subtract(7, 'days').startOf('day');
  const endTime = now.subtract(1, 'day').endOf('day');

  return {
    from: startTime.valueOf(),
    to: endTime.valueOf(),
  };
};

export const getTodayRangeLocalTimestamps = () => {
  const now = dayjs();
  const startOfDay = now.startOf('day');
  const endOfDay = now.endOf('day');

  return {
    from: startOfDay.valueOf(),
    to: endOfDay.valueOf(),
    now: now.valueOf(),
  };
};
